export default "__VITE_ASSET__sNwNfQO8__"